import type {CodeListMap, Part} from 'schemaDefinition/types';
import {useOptionalCodeLists} from 'services/codelists/hooks';
import {usePartCodelistIds} from './usePartCodelistIds';

export const usePartCodelists = (part: Part): CodeListMap | undefined => {
  const ids = usePartCodelistIds(part);
  return useOptionalCodeLists(ids);
};
